<script>
	import { page } from "$app/stores";
	import glogo from "$lib/assets/Google-Logo.wine.svg";
	import { emailIsValid, slugify } from "cando-util";
	import {
		login,
		logout,
		signInWithEmail,
		toggleShow,
	} from "$lib/utilities/loginForm";

	import { store } from "$lib/utilities/store";
	import { translate } from "$lib/utilities/translate";

	import Toast from "$lib/components/Toast.svelte";
	import MarkedContent from "$lib/components/MarkedContent.svelte";

	export let data;
	export let lang;

	let userEmail;
	let loginResponse;

	$: markedContent = translate(
		data?.content?.settings?.["App Settings"]?.[
			`${slugify($page.url.pathname)}LoginPageContent`
		],
		lang,
	);
</script>

<div class="my-10 text-center max-w-2xl mx-auto text-base-content/90">
	<MarkedContent {markedContent} />
</div>

{#if !$store?.userProfile?.uid}
	<h3 class="my-5 text-xl markdown text-center sm:my-10">Login Options</h3>
{/if}

{#if $store?.userProfile?.uid}
	<div class="my-10 text-center">
		<p class="mx-2 my-4 text-xl sm:mx-4 sm:my-8">
			You are currently logged in as: {$store.userProfile.email}
		</p>
		<p class="mx-2 my-4 text-xl sm:mx-4 sm:my-8">
			Click the button below to bail out!
		</p>
	</div>

	<div class="my-10 text-center">
		<button class="btn btn-neutral w-60 rounded-btn" on:click={logout}
			>Confirm Logout</button
		>
	</div>
{:else}
	<div class="my-10 text-center">
		<button class="btn btn-neutral w-60 rounded-btn" on:click={login}>
			Sign In with <span class="px-4 ml-2 bg-white rounded-full">
				<img
					class="w-12"
					width="64"
					height="43"
					src={glogo}
					alt="Google"
				/>
			</span>
		</button>
	</div>

	<div class="my-10 text-center">
		<button
			class="btn btn-neutral w-60 rounded-btn"
			on:click={() => toggleShow("Email-SignIn")}
		>
			Sign In with Email
		</button>

		<div
			id="Email-SignIn"
			class="h-0 overflow-hidden text-2xl transition-all duration-500 ease-in-out"
		>
			<div>
				<p>
					This method requires you to be able to click a link sent to
					the email address you provide below.
				</p>
			</div>
			<div>
				<!-- // 18rems is as big as we can go on my iphone se -->
				<input
					id="user-email-input"
					class="input input-bordered text-center text-lg m-2 w-[18rem]"
					type="email"
					name="email"
					bind:value={userEmail}
					placeholder="Enter Email Address Here"
					autocomplete="off"
				/>
			</div>
			<div>
				<button
					class="btn btn-neutral w-60"
					disabled={!emailIsValid(userEmail)}
					on:click|preventDefault={() =>
						signInWithEmail(loginResponse, userEmail)}
				>
					Send Sign In Link
				</button>
			</div>
		</div>
		<Toast
			elemId="Check-Email"
			message="Sign In Link sent. Check your email. You may have to search your junk folder."
			type="success"
		/>
		<Toast
			elemId="Email-Login-Error"
			bind:message={loginResponse}
			type="error"
		/>
	</div>
{/if}
